export default __webpack_public_path__ + "static/media/pink-plus.6cbc30f4.png";